import React from 'react'

import { ArrowDirectionIcon } from '@application/Interfaces/Icons'
import { TitleDescriptionBulletsType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

import {
    Button,
    Container,
    Description,
    Image,
    Item,
    ItemText,
    Link,
    List,
    Subtitle,
    Title,
    Wrapper,
} from './TitleDescriptionBullets.styled'
import { adjustGridSizeForFullWidth, getListStyleTypeIcon } from './utils'

type Layout = 'default' | 'notitle'

export const TitleDescriptionBullets = (props: TitleDescriptionBulletsType): JSX.Element => {
    const {
        buttonArrowIcon,
        buttonFullWidth,
        buttonLabel,
        buttonLink,
        bulletsDescription,
        image,
        imagePosition,
        imageAnimation,
        subtitle,
        title,
        lists,
        mode,
        fullWidth,
    } = props

    const layout: Layout = title ? 'default' : 'notitle'

    const textColumnProps: Record<string, string | number> = {}

    if (layout === 'notitle') {
        textColumnProps[imagePosition === 'right' ? 'mdUpSpacingRight' : 'mdUpSpacingLeft'] = 6
    }

    return (
        <Wrapper $mode={mode} $fullWidth={fullWidth}>
            <Container>
                <Grid container direction={imagePosition === 'right' ? 'row-reverse' : 'row'}>
                    {!fullWidth && <Grid item md={1} />}
                    <Grid item xs={12} md={adjustGridSizeForFullWidth(4, fullWidth)} textAlign="center">
                        <Image image={image} imageAnimation={imageAnimation} />
                    </Grid>
                    {layout === 'default' && <Grid item md={1} />}
                    <Grid
                        item
                        xs={12}
                        md={
                            layout === 'default'
                                ? adjustGridSizeForFullWidth(5, fullWidth)
                                : adjustGridSizeForFullWidth(6, fullWidth)
                        }
                        {...textColumnProps}
                    >
                        {title && <Title>{title}</Title>}
                        {subtitle && <Subtitle>{subtitle}</Subtitle>}
                        {bulletsDescription && <Description>{bulletsDescription}</Description>}
                        <List>
                            {lists.map((el) => {
                                const Icon = getListStyleTypeIcon(mode, el.listStyleType)

                                return (
                                    <Item key={el.text}>
                                        {Icon}
                                        <ItemText>{el.text}</ItemText>
                                    </Item>
                                )
                            })}
                        </List>
                        {buttonLabel && buttonLink && (
                            <Link to={buttonLink}>
                                <Button fullWidth={buttonFullWidth} mode={mode}>
                                    {buttonLabel}
                                    {buttonArrowIcon && <ArrowDirectionIcon />}
                                </Button>
                            </Link>
                        )}
                    </Grid>
                    {!fullWidth && <Grid item md={1} />}
                </Grid>
            </Container>
        </Wrapper>
    )
}
